import axios from 'axios';
import { auth } from '../firebase';

const getBaseURL = () => {
  if (process.env.REACT_APP_API_BASE_URL) {
    return process.env.REACT_APP_API_BASE_URL;
  }
  return 'http://localhost:5000/api';
};

const api = axios.create({
  baseURL: getBaseURL(),
  timeout: 30000,
  headers: { 'Content-Type': 'application/json' },
});

const getFreshToken = () => {
  return new Promise((resolve) => {
    if (auth.currentUser) {
      auth.currentUser.getIdToken(true).then(resolve).catch(() => resolve(null));
      return;
    }
    const unsub = auth.onAuthStateChanged((user) => {
      unsub();
      user ? user.getIdToken(true).then(resolve).catch(() => resolve(null)) : resolve(null);
    });
  });
};

api.interceptors.request.use(
  async (config) => {
    try {
      const token = await getFreshToken();
      if (token) config.headers.Authorization = `Bearer ${token}`;
    } catch (err) {
      console.error('Token error:', err);
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const orig = error.config;
    if (error.response?.status === 401 && !orig._retry) {
      orig._retry = true;
      try {
        const token = await getFreshToken();
        if (token) {
          orig.headers.Authorization = `Bearer ${token}`;
          return api(orig);
        }
      } catch (err) { /* fail silently */ }
    }
    if (!error.response) {
      return Promise.reject({ message: 'Network error. Please check your connection.', type: 'network' });
    }
    return Promise.reject({
      message: error.response?.data?.message || error.message || 'Something went wrong',
      status: error.response?.status,
    });
  }
);

export default api;